import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const bp = 'sm'

type StylesType = {
  readOnly?: boolean
  canEdit?: boolean
  smallMedia?: boolean
  timelineMode?: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      fontSize: theme.size.sm
    }
  },

  groupBorder: {
    '& > :not(:last-child)': {
      marginBottom: '1.5rem',
      // @ts-ignore
      borderBottom: `1px solid ${theme.border.separator}`,
      boxSizing: 'border-box'
    }
  },

  grid: {
    padding: '1.5rem 0px',
    width: '100%',
    columnCount: 2,

    [theme.breakpoints.down(bp)]: {
      columnCount: 1
    }
  },

  gridReal: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    width: '100%',
    padding: '1.5rem 0px',

    [theme.breakpoints.down(bp)]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },

  gridItem: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '35px'
  },

  noDataSection: {
    display: 'flex',
    justifyContent: 'center',
    color: 'grey',
    fontSize: theme.size.sm,
    marginBottom: '0.5rem'
  },

  columnRoot: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    flex: '1'
  },

  column: {
    color: 'grey',
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '50%',
    flex: '1',
    padding: ({ readOnly, timelineMode }) =>
      readOnly || timelineMode ? '0 !important' : '1.5rem 0',
    fontSize: ({ readOnly }) => (readOnly ? theme.size.sm : 'inherit'),

    '& > div': {
      fontSize: theme.size.sm,
      height: '35px',
      display: ({ readOnly }) => (readOnly ? 'flex' : 'inherit'),
      alignItems: 'center',

      [theme.breakpoints.down(bp)]: {
        height: ({ readOnly }) => (readOnly ? '35px' : 'unset'),
        flexDirection: ({ readOnly }) => (readOnly ? 'row' : 'column'),
        alignItems: ({ readOnly }) => (readOnly ? 'center' : 'flex-start'),
        justifyContent: ({ readOnly }) => (readOnly ? 'flex-start' : 'center'),
        paddingTop: ({ readOnly, smallMedia }) =>
          readOnly ? '0' : smallMedia ? '1rem' : '2rem'
      }
    },

    [theme.breakpoints.down(bp)]: {
      flex: '1',
      flexBasis: '100%',
      padding: '0 !important'
    }
  },

  title: {
    flexBasis: '100%',
    display: ({ readOnly }) => (readOnly ? 'none' : 'flex'),
    justifyContent: 'center',
    flexDirection: 'column',
    color: '#323436',
    fontSize: theme.size.sm,

    '& > :nth-child(2)': {
      opacity: '0.75',
      color: '#323436',
      fontSize: theme.size.sm,
      fontStyle: 'italic'
    },

    [theme.breakpoints.down('lg')]: {
      paddingTop: '0',
      paddingBottom: '0.5rem'
    }
  },

  select: {
    marginLeft: '2rem',
    height: '15px',
    cursor: ({ readOnly, canEdit }) =>
      canEdit
        ? readOnly
          ? 'not-allowed !important'
          : 'auto'
        : 'default !important',
    // background of select box
    '& > div': {
      backgroundColor: 'transparent',
      paddingLeft: '0'
    },

    '& .MuiSelect-select.Mui-disabled': {
      cursor: ({ readOnly, canEdit }) =>
        canEdit ? (readOnly ? 'not-allowed !important' : 'auto') : 'default'
    }
  },

  calendar: {
    display: 'flex'
  },

  calendarSelect: {
    marginLeft: '2rem',
    color: 'black',
    opacity: '0.5',
    cursor: ({ readOnly, canEdit }) =>
      canEdit ? (readOnly ? 'not-allowed' : 'pointer') : 'default'
  },

  maritalStatus: {
    marginLeft: '2rem',
    color: 'black',
    opacity: '0.5',
    cursor: ({ readOnly, canEdit }) =>
      canEdit ? (readOnly ? 'not-allowed' : 'pointer') : 'default',
    textOverflow: 'ellipsis',
    maxWidth: 0
  },

  noInfo: {
    color: '#657786',
    fontSize: theme.size.sm
  },

  arrow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: theme.size.sm
  },

  error: {
    marginLeft: '1rem',
    color: 'red',
    [theme.breakpoints.down(bp)]: {
      marginLeft: '0'
    }
  }
}))

export default useStyles
